import React, { Component } from "react";
import { Row, Col, Card, CardBody, Badge, FormGroup } from "reactstrap";
import Ionicon from "react-ionicons";
import Moment from "react-moment";
import { Redirect, withRouter } from '../../utils/router-compat';
import _ from "lodash";
import OfftakeEntryService from "../../services/OfftakeEntryService";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import HODashboardService from "../../services/HODashaboardService";

class OfftakeEntriesVerificationStatus extends Component {
  state = {
    offtakeEntries: [],
    offtakeEntriesCloned: [],
    offtakeEntriesCount: [],
    redirectToEditOfftakeEntry: false,
    uuid: "",
    clickedStatus: "all",
    isLoading: false,
    memberId: null,
    memberName: null,
    sapid: null,
    yearOptions: [],
    year: null,
    year_name_value: {},
    zone: null,
    HOD: null,
    c_f_d: null,
  };

  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    const searchParam = this.props.location.search;
    let memberUuid = null;
    let year = null;
    let dealerName = null;
    if (searchParam) {
      const keys = searchParam.split("&");
      const idString = keys[0];
      const nameString = keys[1];
      const id = idString.split("=");
      if (id[0] === "?y") {
        year = id[1];
      } else {
        memberUuid = id[1];
      }
      const name = nameString ? nameString.split("=") : null;
      dealerName = name ? decodeURI(name[1]) : null;
      const sap = keys[2] ? keys[2].split("=") : null;
      let sapid = sap ? decodeURI(sap[1]) : null;
      const zoneid = keys[3] ? keys[3].split("=") : null;
      let zone = zoneid ? decodeURI(zoneid[1]) : null;
      const HODid = keys[4] ? keys[4].split("=") : null;
      let HOD = HODid ? HODid[1] : null;
      const selYear = keys[5] ? keys[5].split("=") : null;
      if (id[0] !== "?y") {
        year = selYear ? selYear[1] : null;
      }
      const cfd = keys[6] ? keys[6].split("=") : null;
      let c_f_d = cfd ? cfd[1] : null;
      this.setState(
        {
          memberId: memberUuid,
          memberName: dealerName,
          sapid,
          zone,
          HOD,
          year,
          c_f_d,
        },
        () => {
          this.filterAPI();
        }
      );

      // if (memberUuid) {
      //   this.loadInitialData(memberUuid);
      // } else {
      //   this.loadInitialData();
      // }
    } else {
      this.filterAPI();
      // this.loadInitialData();
    }
  }

  loadInitialData = (uuid) => {
    this.getOfftakeEntries(false, uuid);
    this.getOfftakeEntriesCount(uuid);
  };

  downloadReport = () => {
    const memberId = this.state.memberId;
    this.getOfftakeEntries(true, memberId);
  };

  getOfftakeEntries = async (downloadReport, uuid) => {
    let { offtakeEntries, offtakeEntriesCloned, isLoading } = this.state;

    try {
      // if (!downloadReport) {
      isLoading = true;
      this.setState({ isLoading });
      // }
      const { data } = await OfftakeEntryService.getOfftakeEntries(
        downloadReport,
        uuid,
        this.state.year
      );
      isLoading = false;
      this.setState({ isLoading });
      if (data && !downloadReport) {
        offtakeEntries = data.data;
        offtakeEntriesCloned = _.cloneDeep(data.data);
      } else if (data.data && data.data.file) {
        const link = document.createElement("a");
        link.href = data.data.file;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.setState({ offtakeEntries, offtakeEntriesCloned });
    } catch (error) {
      console.log(error);
    }
  };

  getOfftakeEntriesCount = async (uuid) => {
    let { offtakeEntriesCount } = this.state;
    try {
      const { data } = await OfftakeEntryService.getOfftakeEntriesCount(
        uuid,
        this.state.year
      );
      if (data) {
        offtakeEntriesCount = data.data;
        offtakeEntriesCount = _.sortBy(offtakeEntriesCount, "status");
      }
      this.setState({ offtakeEntriesCount });
    } catch (error) {
      console.log(error);
    }
  };

  onInvoiceClick = (uuid) => {
    let { redirectToEditOfftakeEntry } = this.state;
    redirectToEditOfftakeEntry = true;
    this.setState({ redirectToEditOfftakeEntry, uuid: window.btoa(uuid) });
  };

  onClickStatus = (status = "") => {
    let { clickedStatus, offtakeEntries, offtakeEntriesCloned } = this.state;
    clickedStatus = status;

    if (clickedStatus.toLowerCase() === "all") {
      offtakeEntries = offtakeEntriesCloned;
      this.setState({ clickedStatus, offtakeEntries });
      return;
    }

    offtakeEntries = _.filter(offtakeEntriesCloned, (item) => {
      if ((status || "").toLowerCase() === "pending") {
        return (
          (item.status || "").toLowerCase() === status.toLowerCase() ||
          (item.status || "").toLowerCase() === "pending_zfm"
        );
      }
      return (item.status || "").toLowerCase() === status.toLowerCase();
    });

    this.setState({ clickedStatus, offtakeEntries });
  };

  sortData = (columnName, sort) => {
    let { offtakeEntries } = this.state;
    if (sort === "asc") {
      if (columnName === "purchase_date" || columnName === "created_at") {
        offtakeEntries = offtakeEntries.sort((a, b) => {
          return new Date(a[columnName]) - new Date(b[columnName]);
        });
      } else {
        offtakeEntries = offtakeEntries.sort((a, b) => {
          return new a[columnName]() - b[columnName];
        });
      }
    } else if (columnName === "purchase_date" || columnName === "created_at") {
      offtakeEntries = offtakeEntries.sort((a, b) => {
        return new Date(b[columnName]) - new Date(a[columnName]);
      });
    } else {
      offtakeEntries = offtakeEntries.sort((a, b) => {
        return new b[columnName]() - a[columnName];
      });
    }

    this.setState({ offtakeEntries });
  };

  openReportPage = () => {
    const { memberId, memberName, sapid } = this.state;
    const url = `/?id=${memberId}&name=${memberName}&sapid=${sapid}&zone=${this.state.zone}&HOD=${this.state.HOD}&y=${this.state.year}&cfd=${this.state.c_f_d}`;
    if (this.props.history) {
        this.props.history.push(url);
    } else if (this.props.router && this.props.router.navigate) {
        this.props.router.navigate(url);
    }
  };

  filterAPI = () => {
    const { year } = this.state;

    let filter = {
      y: year ? year : null,
    };
    this.setState({ isLoader: true });
    HODashboardService.filterAPI(filter)
      .then((res) => {
        if (res.data.data) {
          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : [],
              isLoader: false,
            },
            () => {
              if (
                !this.state.year &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                this.setState(
                  {
                    year: this.state.yearOptions[0].value,
                    year_name_value: this.state.yearOptions[0],
                  },
                  () => {
                    const searchParam = this.props.location.search;
                    if (searchParam) {
                      if (this.state.memberId) {
                        this.loadInitialData(this.state.memberId);
                      } else {
                        this.loadInitialData();
                      }
                    } else {
                      this.loadInitialData();
                    }
                  }
                );
              } else {
                this.loadInitialData(this.state.memberId);
              }
            }
          );
          this.props.updateZone();
        }
      })
      .catch((err) => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  onChangeYear = (e) => {
    this.setState(
      {
        year: e && e.target && e.target.value,
      },
      () => {
        // this.filterAPI();
        let { yearOptions, year_name_value, year } = this.state;
        if (year) {
          year_name_value = yearOptions.filter((x) => x.value == year);
        }
        if (year_name_value) {
          year_name_value =
            year_name_value && year_name_value[0]
              ? year_name_value[0]
              : year_name_value;
          this.setState({ year_name_value });
          this.loadInitialData(this.state.memberId);
        }
      }
    );
  };

  render() {
    const {
      isLoading,
      offtakeEntriesCount,
      offtakeEntries,
      offtakeEntriesCloned,
      redirectToEditOfftakeEntry,
      uuid,
      clickedStatus,
      memberId,
      memberName,
    } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}

        {
          <>
            {memberId && redirectToEditOfftakeEntry && (
              <Redirect
                to={{
                  pathname: "/editOfftakeEntry",
                  search: `q=${uuid}&id=${memberId}&name=${memberName}`,
                }}
              />
            )}
            {!memberId && redirectToEditOfftakeEntry && (
              <Redirect
                to={{ pathname: "/editOfftakeEntry", search: `q=${uuid}` }}
              />
            )}
            {memberId && (
              <Row>
                <Col>
                  {/* <span className="prev-page-link cursor-pointer" onClick={this.openDashboard}>Offtake Entries Verification Status</span>
                <span>
                  <Ionicon icon="ios-arrow-forward" fontSize="34px" color="#fdbb1f" />
                </span> */}
                  <span
                    className="prev-page-link cursor-pointer "
                    onClick={this.openReportPage}
                  >
                    Points report for{" "}
                    <span className="title-case">{memberName}</span>
                  </span>
                  <span>
                    <Ionicon
                      icon="ios-arrow-forward"
                      fontSize="34px"
                      color="#fdbb1f"
                    />
                  </span>
                  <span className="current-page">
                    Offtake Entries Verification Status{" "}
                    <span className="title-case">{memberName}</span>
                  </span>
                </Col>
              </Row>
            )}
            {/* <Row>
              <Col>
                <span className="offtake-title">Offtake Entries Verification Status</span>
              </Col>

            </Row> */}

            {/* {offtakeEntriesCloned && offtakeEntriesCloned.length > 0 && ( */}
            <Row style={{ marginTop: "15px" }}>
              <Col>
                <Card>
                  <CardBody>
                    <Row
                      style={{
                        marginLeft:
                          this.state.yearOptions.length > 1 ? "-25px" : "-10px",
                        marginBottom: "-10px",
                      }}
                    >
                      <Col
                        style={{ display: "flex" }}
                        md={this.state.yearOptions.length > 1 ? "8" : "10"}
                        xs="12"
                      >
                        {(offtakeEntriesCount || []).map((item) => {
                          return (
                            <div
                              key={item.status}
                              onClick={(e) => this.onClickStatus(item.status)}
                              className={
                                item.status === clickedStatus
                                  ? "offtake-status-div-active"
                                  : "offtake-status-div"
                              }
                              style={{ marginLeft: "10px", display: "flex" }}
                            >
                              {(item.status || "").toLowerCase() === "all" && (
                                <span
                                  className="offtake-count-status"
                                  style={{ color: "#6e777f" }}
                                >
                                  {item.count}
                                </span>
                              )}
                              {(item.status || "").toLowerCase() ===
                                "pending" && (
                                <span
                                  className="offtake-count-status"
                                  style={{ color: "#e47927" }}
                                >
                                  {item.count}
                                </span>
                              )}

                              {(item.status || "").toLowerCase() ===
                                "rejected" && (
                                <span
                                  className="offtake-count-status"
                                  style={{ color: "#e66c6c" }}
                                >
                                  {item.count}
                                </span>
                              )}

                              {(item.status || "").toLowerCase() ===
                                "approved" && (
                                <span
                                  className="offtake-count-status"
                                  style={{ color: "#51b856" }}
                                >
                                  {item.count}
                                </span>
                              )}
                              <div className="offtake-text-status">
                                {item.status}
                              </div>
                            </div>
                          );
                        })}
                      </Col>
                      {this.state.yearOptions.length > 1 && (
                        <Col md="2" xs="12">
                          <FormGroup>
                            <select
                              name="month"
                              className="form-control cursor-pointer"
                              value={this.state.year}
                              onChange={(e) => {
                                this.onChangeYear(e);
                              }}
                            >
                              {this.state.yearOptions.map((item) => (
                                <option value={item.value} selected>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </Col>
                      )}
                      <Col md="2" xs="12">
                        <div
                          className="d-flex-row Download-report-wrapp pull-right"
                          style={{ cursor: "pointer" }}
                        >
                          <img src="images/group-6.svg" alt="" />{" "}
                          <span
                            className="Download-Full-Report"
                            onClick={this.downloadReport}
                          >
                            Download Full Report
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <div className="showingText">
                      Financial Year{" "}
                      {this.state.year_name_value &&
                        this.state.year_name_value.name}
                      .
                    </div>

                    <Row style={{ marginTop: "15px" }}>
                      <Col>
                        <table className="table table-bordered table-responsive">
                          <thead
                            id="wc-table-head"
                            className="offtake-check-table-head"
                          >
                            <tr>
                              <th style={{textAlign: 'center'}}>Submitted Date</th>
                              <th style={{textAlign: 'center'}}>Purchased Date</th>
                              <th style={{textAlign: 'center'}}>Invoice Number</th>
                              <th style={{textAlign: 'center'}}>Quantity</th>
                              <th style={{textAlign: 'center'}}>Invoice in favour of</th>
                              <th style={{textAlign: 'center'}}>Dealer Name</th>
                              <th style={{textAlign: 'center'}}>Status</th>
                            </tr>
                          </thead>
                          <tbody id="wc-table-body">
                            {(offtakeEntries || []).map((item, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    <Moment format="DD MMM YYYY">
                                      {item.created_at}
                                    </Moment>
                                  </td>
                                  <td>
                                    <Moment format="DD MMM YYYY">
                                      {item.purchase_date}
                                    </Moment>
                                  </td>
                                  <td>
                                    <span
                                      onClick={(e) =>
                                        this.onInvoiceClick(item.uuid)
                                      }
                                      className="Download-Full-Report"
                                      style={{
                                        fontSize: "12px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {item.invoice_number}
                                    </span>
                                  </td>
                                  <td style={{ fontWeight: "normal" }}>
                                    {item.quantity}
                                  </td>
                                  <td style={{ fontWeight: "normal" }}>
                                    {item.subsidiary_name}
                                  </td>
                                  <td style={{ fontWeight: "normal" }}>
                                    {item.dealer_name}
                                  </td>
                                  <td style={{ width: "200px" }}>
                                    {(item.status || "").toLowerCase() ===
                                      "pending" && (
                                      <Badge
                                        color="primary"
                                        className="offtake-status-table"
                                        style={{
                                          backgroundColor:
                                            "rgb(228, 121, 39) !important",
                                        }}
                                      >
                                        {item.status}
                                      </Badge>
                                    )}
                                    {(item.status || "").toLowerCase() ===
                                      "pending_zfm" && (
                                      <Badge
                                        color="primary"
                                        className="offtake-status-table-zfm"
                                        style={{
                                          backgroundColor:
                                            "rgb(228, 121, 39) !important",
                                        }}
                                      >
                                        Pending ZFM
                                      </Badge>
                                    )}
                                    {(item.status || "").toLowerCase() ===
                                      "approved" && (
                                      <Badge
                                        color="success"
                                        className="offtake-status-table"
                                        style={{
                                          backgroundColor: "#51b856 !important",
                                        }}
                                      >
                                        {item.status}
                                      </Badge>
                                    )}
                                    {(item.status || "").toLowerCase() ===
                                      "rejected" && (
                                      <Badge
                                        color="danger"
                                        className="offtake-status-table"
                                        style={{
                                          backgroundColor: "#e66c6c !important",
                                        }}
                                      >
                                        {item.status}
                                      </Badge>
                                    )}
                                    &nbsp;
                                    <span
                                      title={item.remark}
                                      className="incorrect-entries-label text-overflow-dots"
                                    >
                                      {item.remark}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}

                            {offtakeEntries && offtakeEntries.length === 0 && (
                              <tr>
                                <td
                                  colSpan="6"
                                  style={{ fontSize: "18px", color: "grey" }}
                                >
                                  <center>No match found</center>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {/* )} */}

            {offtakeEntriesCloned && offtakeEntriesCloned.length === 0 && (
              <Row style={{ marginTop: "15px" }}>
                <Col>
                  <Card>
                    <CardBody style={{ fontSize: "18px", color: "grey" }}>
                      <center>No records found</center>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </>
        }
      </div>
    );
  }
}

export default withRouter(OfftakeEntriesVerificationStatus);
